import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "blockContainer",
  data: {
    styles: {
      maxHeight: "470px",
    },
    block: {
      type: "image",
      options: {
        src: `${config.ASSETS_URL}/03/case-01/principle/2-2.png`,
      },
    },
  },
};

export default component;
